import { environment } from 'src/environments/environment';

export type EmailOtpIdp = 'entra' | 'google';

/** When `emailOtpIdp` is google: numeric OTP vs Firebase passwordless email link. */
export type GoogleEmailOtpDelivery =
  | 'acs'
  | 'twilio_verify'
  | 'firebase_passwordless';

/** From Angular environment (`emailOtpIdp`) — mirrors backend `EMAIL_OTP_IDP`. */
export function getEmailOtpIdp(): EmailOtpIdp {
  return environment.emailOtpIdp === 'google' ? 'google' : 'entra';
}

export function useGoogleEmailOtpIdp(): boolean {
  return getEmailOtpIdp() === 'google';
}

/** Mirrors backend `GOOGLE_EMAIL_OTP_DELIVERY` (default `acs`). */
export function getGoogleEmailOtpDelivery(): GoogleEmailOtpDelivery {
  if (!useGoogleEmailOtpIdp()) {
    return 'acs';
  }
  const mode = environment.googleEmailOtpDelivery;
  if (mode === 'firebase_passwordless' || mode === 'twilio_verify') {
    return mode;
  }
  return 'acs';
}

export function useNumericGoogleEmailOtp(): boolean {
  const delivery = getGoogleEmailOtpDelivery();
  return delivery === 'acs' || delivery === 'twilio_verify';
}

export function useAcsGoogleEmailOtp(): boolean {
  return (
    useGoogleEmailOtpIdp() && getGoogleEmailOtpDelivery() === 'acs'
  );
}

export function useTwilioVerifyGoogleEmailOtp(): boolean {
  return (
    useGoogleEmailOtpIdp() &&
    getGoogleEmailOtpDelivery() === 'twilio_verify'
  );
}

export function useFirebasePasswordlessEmail(): boolean {
  return (
    useGoogleEmailOtpIdp() &&
    getGoogleEmailOtpDelivery() === 'firebase_passwordless'
  );
}

/** Continue with Google / Apple clickable when `emailOtpIdp` is `google`. */
export function isSocialSignInEnabled(): boolean {
  return useGoogleEmailOtpIdp();
}
